<template>
  <v-dialog
    v-model="active"
    persistent
    transition="dialog-bottom-transition"
    style="z-index: 2000"
    max-width="800"
    :retain-focus="false"
    :scrollable="true"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card
      class="text-center"
      :class="
        getTheme() == 'dark' ? 'outlined elevation-0' : 'flat elevation-0'
      "
      :style="getTheme() == 'dark' ? '' : 'border-bottom: 1px solid lightgray'"
    >
      <v-card-title
        :style="
          getTheme() == 'dark'
            ? 'background-color: #505050'
            : 'background-color: white; border-bottom: 1px solid lightgray'
        "
        :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
        class="title font-weight-regular"
      >
        <v-icon
          :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
          class="mr-3"
          medium
          >{{ icon }}</v-icon
        >
        {{ title }}
      </v-card-title>
      <v-card-text class="pb-4 pt-6"
        ><div style="text-align: left" v-html="body"></div
      ></v-card-text>
      <v-card-actions
        :class="getTheme() == 'dark' ? '#505050--text' : '#505050--text'"
        :style="
          getTheme() == 'dark'
            ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
            : 'background-color: white; border-top: 1px solid lightgray;'
        "
      >
        <v-spacer></v-spacer>
        <v-btn color="primary" text class="mx-0" @click="clickYes">{{
          $t("msgUnderstand")
        }}</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "dialog-basic-msg",
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    body: {
      type: String,
      required: true,
    },
  },
  methods: {
    clickYes: function () {
      this.$emit("clickYes");
    },
  },
};
</script>

<style scoped>
</style>